import React from 'react';
import MiniDrawer from '../components/Header';
import AdminPageContent from '../components/admin/AdminPageContent';
export default function AdminPage({ token }) {
    return (React.createElement(MiniDrawer, { type: "admin" },
        React.createElement(AdminPageContent, { token: token })));
}
